import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";



const General = () => {
  return (
    <Container>
    <h2 className="display-6 fw-bold my-4">General Peer-Review and Editorial Procedures

    </h2>
    <hr />

    <p className="joab-common-para my-4">All manuscripts sent for publication in our journals are strictly and thoroughly peer-reviewed by experts (this includes research and review articles, spontaneous submissions, and invited papers). The Managing Editor of the journal will perform an initial check of the manuscript’s suitability upon receipt. The Editorial Office will then organize the peer-review process performed by independent experts and collect at least two review reports per manuscript. We ask our authors for adequate revisions (with a second round of peer-review if necessary) before a final decision is made. The final decision is made by the academic editor (usually the Editor-in-Chief of a journal or the Guest Editor of a Special Issue). Accepted articles are copy-edited and English-edited.</p>

  
   


  </Container>
  );
};

export default General;
